import { buttonsFromSerializedInAppMessage as pe } from "../in-app-message-factory.js";
import InAppMessage from "./in-app-message.js";
export default class ModalMessage extends InAppMessage {
  constructor(
    e,
    r,
    s,
    t,
    i,
    o,
    a,
    p,
    m,
    n,
    u,
    c,
    d,
    f,
    l,
    g,
    j,
    v,
    x,
    z,
    h,
    w,
    y,
    S,
    b,
    k,
    q,
    A,
  ) {
    super(
      e,
      r,
      void 0,
      s,
      t,
      i,
      o,
      a,
      (p = p || InAppMessage.DismissType.MANUAL),
      m,
      n,
      u,
      c,
      d,
      f,
      l,
      g,
      j,
      v,
      x,
      z,
      h,
      w,
      y,
      S,
      (b = b || InAppMessage.CropType.FIT_CENTER),
      void 0,
      k,
      q,
      A,
    ),
      (this.$o = InAppMessage.TextAlignment.CENTER);
  }
  bt() {
    return super.bt(ModalMessage.cs);
  }
  static Qr(e) {
    return new ModalMessage(
      e[InAppMessage.es.ra],
      e[InAppMessage.es.sa],
      e[InAppMessage.es.qs],
      e[InAppMessage.es.ta],
      e[InAppMessage.es.ia],
      e[InAppMessage.es.URI],
      e[InAppMessage.es.oa],
      e[InAppMessage.es.pa],
      e[InAppMessage.es.ma],
      e[InAppMessage.es.na],
      e[InAppMessage.es.ls],
      e[InAppMessage.es.ua],
      e[InAppMessage.es.ca],
      e[InAppMessage.es.fa],
      e[InAppMessage.es.da],
      e[InAppMessage.es.la],
      e[InAppMessage.es.ga],
      e[InAppMessage.es.ja],
      e[InAppMessage.es.xa],
      e[InAppMessage.es.za],
      e[InAppMessage.es.ha],
      e[InAppMessage.es.va],
      e[InAppMessage.es.wa],
      pe(e[InAppMessage.es.ya]),
      e[InAppMessage.es.Sa],
      e[InAppMessage.es.ka],
      e[InAppMessage.es.CSS],
      e[InAppMessage.es.qa],
    );
  }
}
ModalMessage.cs = InAppMessage.bo.Vr;
